import { render } from "./ViewCuratorRequestsDialog.vue?vue&type=template&id=89efc298&scoped=true"
import script from "./ViewCuratorRequestsDialog.vue?vue&type=script&lang=js"
export * from "./ViewCuratorRequestsDialog.vue?vue&type=script&lang=js"

import "./ViewCuratorRequestsDialog.vue?vue&type=style&index=0&id=89efc298&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89efc298"]])

export default __exports__